<div #opLanguageSelectorRootEle class="op-language-selector">
  <p-select
    [filter]="true"
    [options]="languages()"
    optionLabel="label"
    optionValue="language"
    [appendTo]="opLanguageSelectorRootEle"
    [ngModel]="langModel()"
    (ngModelChange)="_change($event)" />
</div>
